import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Database, Loader2, AlertTriangle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const MasterDataAnalysis = ({ project }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [project.id]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API}/projects/${project.id}/discovery/master-data`);
      setData(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !data) return <Loader2 className="w-12 h-12 animate-spin mx-auto mt-20" />;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
      <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
        <Database className="w-6 h-6 mr-3 text-purple-600" />
        Master Data Analysis
      </h3>
      <div className="space-y-6">
        {Object.entries(data.modules).map(([module, entities]) => (
          <div key={module} className="border-2 border-purple-200 rounded-xl p-5">
            <h4 className="text-xl font-bold text-gray-900 mb-4 px-3 py-1 bg-purple-100 text-purple-700 rounded-lg inline-block">
              {module} Module
            </h4>
            <div className="grid md:grid-cols-2 gap-4">
              {Object.entries(entities).map(([entity, info]) => (
                <div key={entity} className="bg-gray-50 rounded-lg p-4">
                  <p className="font-semibold text-gray-900 mb-2 capitalize">{entity.replace(/_/g, ' ')}</p>
                  <p className="text-2xl font-bold text-purple-600 mb-2">{info.count.toLocaleString()}</p>
                  {info.issues && info.issues.length > 0 && (
                    <div className="space-y-1">
                      {info.issues.map((issue, idx) => (
                        <div key={idx} className="flex items-start space-x-2">
                          <AlertTriangle className="w-4 h-4 text-orange-600 flex-shrink-0 mt-0.5" />
                          <p className="text-xs text-orange-700">{issue}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};